var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5667 18.1873L13.1498 11.7703C12.5721 11.1926 12.5721 10.2556 13.1498 9.67787L19.5233 3.30426C20.1011 2.72652 20.1011 1.78956 19.5233 1.21148L19.5025 1.19065C18.9244 0.612564 17.9875 0.612564 17.4098 1.19065L11.0363 7.56426C10.4582 8.142 9.52124 8.142 8.94351 7.56426L2.5263 1.14694C1.94823 0.568858 1.01129 0.568858 0.433556 1.14694C-0.144519 1.72469 -0.144519 2.66164 0.433556 3.23972L6.85111 9.6567C7.42884 10.2344 7.42884 11.1717 6.85111 11.7495L0.477262 18.1234C-0.100813 18.7012 -0.100813 19.6381 0.477262 20.2159L0.49809 20.237C1.07616 20.8148 2.01276 20.8148 2.59049 20.237L8.96468 13.8631C9.54276 13.2854 10.4794 13.2854 11.0571 13.8631L17.4743 20.2801C18.052 20.8578 18.989 20.8578 19.5667 20.2801C20.1444 19.7023 20.1444 18.765 19.5667 18.1873Z",
    className: "color1Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.48260ef9c0c52b75e7e515b9c877c059.svg";
export { ForwardRef as ReactComponent };